'use client';

import MuiAutocomplete, {
  createFilterOptions as MuiCreateFilterOptions,
} from '@mui/material/Autocomplete';

export const Autocomplete = MuiAutocomplete;

export const createFilterOptions = MuiCreateFilterOptions;
